import React from 'react';
import { useHistory } from 'react-router-dom';

import { storageAvailable } from '../../helpers';
import { useApp } from '../../state/app';
import { useUser } from '../../state/user';

import FccSetPlan from './FCC';

const PreRegSetPlan = () => {
  const { tempPhoneNumber } = useUser();
  const { showFccPreReg: showFccPreRegFromRedux } = useApp();
  const showFccPreRegFromSession =
    storageAvailable('sessionStorage') &&
    sessionStorage.getItem('showFccPreReg');

  if ((showFccPreRegFromRedux || showFccPreRegFromSession) && tempPhoneNumber) {
    return <FccSetPlan />;
  }

  // redirect if not a credit user or we don't have a phone number
  const history = useHistory();
  history.replace('/');
  return null;
};

export default PreRegSetPlan;
